import { c as _c } from "react/compiler-runtime";
import { motion } from "motion/react";
import React from "react";
import { usePathname } from "next/navigation";
import { useCommunication } from "@/contexts/chat-provider";
import { useTenant } from "@/contexts/tenant-provider";
import ChatWindow from "./chat-window";
import HiddenChatsDropdown from "./hidden-chats-dropdown";
import MessagingSidebar from "./messaging-sidebar";
import AddChatWindow from "./new-chat";
import { useNavigationSidebarOpenStore } from "@/stores/navigation-sidebar-store";
import { selectSidebarOpen, useRightSidebarStore } from "@/stores/right-sidebar-store";
import { useTeamChatDrawerStore } from "@/stores/team-chat-store";
const WHISPER_PANEL_WIDTH = 700;
const BASE_GAP = 8; // 0.5rem

export const GlobalChat: React.FC = () => {
  const $ = _c(17);
  const pathname = usePathname();
  const {
    visibleChats,
    hiddenChats,
    isAddChatOpen
  } = useCommunication();
  const {
    tenant
  } = useTenant();
  const isWhisperOpen = useTeamChatDrawerStore(_temp);
  const isRightSidebarOpen = useRightSidebarStore(selectSidebarOpen);
  const rightSidebarWidth = useRightSidebarStore(_temp2);
  const isSidebarCollapsed = useNavigationSidebarOpenStore(_temp3);
  const rightOffset = isWhisperOpen ? WHISPER_PANEL_WIDTH + BASE_GAP : isRightSidebarOpen ? rightSidebarWidth + BASE_GAP * 2 : 0;
  let t0;
  if ($[0] !== rightOffset) {
    t0 = rightOffset > 0 ? {
      right: `${rightOffset}px`
    } : undefined;
    $[0] = rightOffset;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const rightStyle = t0;
  const shouldHideChatWindows = isWhisperOpen && !isSidebarCollapsed;
  if (!tenant?.enabledModules.some(_temp4)) {
    return null;
  }
  if (pathname.includes("/comms/chat")) {
    return null;
  }
  if (pathname.includes("/ask-decoda")) {
    return null;
  }
  let t1;
  if ($[2] !== hiddenChats || $[3] !== shouldHideChatWindows) {
    t1 = !shouldHideChatWindows && hiddenChats.length > 0 && <motion.div className="pointer-events-auto" layout={true} layoutId="hidden-chats-dropdown"><HiddenChatsDropdown chats={hiddenChats} /></motion.div>;
    $[2] = hiddenChats;
    $[3] = shouldHideChatWindows;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== shouldHideChatWindows || $[6] !== visibleChats) {
    t2 = !shouldHideChatWindows && [...visibleChats].reverse().map(_temp5);
    $[5] = shouldHideChatWindows;
    $[6] = visibleChats;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== isAddChatOpen || $[9] !== shouldHideChatWindows) {
    t3 = !shouldHideChatWindows && isAddChatOpen && <motion.div className="pointer-events-auto" layout={true} layoutId="add-chat-window"><AddChatWindow /></motion.div>;
    $[8] = isAddChatOpen;
    $[9] = shouldHideChatWindows;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="pointer-events-auto"><MessagingSidebar /></div>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== rightStyle || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t5 = <div className="pointer-events-none fixed bottom-2 right-2 z-40 flex h-0 items-end space-x-4 pt-2 transition-[right] duration-200" style={rightStyle}>{t1}{t2}{t3}{t4}</div>;
    $[12] = rightStyle;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default GlobalChat;
function _temp(s) {
  return s.isOpen;
}
function _temp2(s_0) {
  return s_0.width;
}
function _temp3(s_1) {
  return s_1.isCollapsed;
}
function _temp4(module) {
  return module === "TEXTING" || module === "CALLING";
}
function _temp5(chat) {
  return <motion.div key={`chat-${chat.chatId}`} layout={true} layoutId={`chat-${chat.chatId}`} className="pointer-events-auto"><ChatWindow windowProps={chat} /></motion.div>;
}